export const PROCESS_STATES = {
  COMPLETED: 'Completado',
  CREATED: 'En creación',
  ERROR: 'Error',
  PROCESSING: 'Procesando',
}

export const ATTRIBUTE_MAPPING: Record<string, string> = {
  transunion_unholster: 'Unholster',
  padronelectoral: 'Unholster Comunas',
}

export const stateColors: Record<string, string> = {
  [PROCESS_STATES.COMPLETED]: 'bg-[#27AE60]',
  [PROCESS_STATES.CREATED]: 'bg-[#BDBDBD]',
  [PROCESS_STATES.ERROR]: 'bg-[#EB5757]',
  [PROCESS_STATES.PROCESSING]: 'bg-[#333333]',
}
